export default __webpack_public_path__ + "static/media/delete-two.2ecc00d3.svg";